export default "__VITE_ASSET__7a1b3b38__"